import { gql } from 'apollo-boost';
import { STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/structured-content-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

// input UpdateMessageInput {
// 	messageId: ID!
// 	content: MessageContent!
// }

export const UPDATE_MESSAGE = gql`
    mutation($data: UpdateMessageInput!) {
        updateMessage(data: $data) {
            id
            parentMessageId
            referencedMessageId
            threadRootMessageId
            email { subject from receivedAt preview hasOriginalHtml }
            laneKind
            aiRole
            title
            body
            createdAt
            updatedAt
            deletedAt
            type {
                type
            }
            image {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                width
                height
                aspect_ratio
                duration
                public_id
            }
            file {
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                mime
                width
                height
                aspect_ratio
                duration
            }
            cursor
            isCheckbox
            isChecked
            isStarred
            reminderAt
            eventArtifactId
            event { startDate endDate startTime endTime timeZone location rawDate needsReview }
            reminderUpdatedAt
            reminderFiredAt
            reminderCancelledAt
            reminderVersion
            reminderDeliveryType
            reminderMessage
            automaticReminderNeedsReview
            dueAt
            dueTimezone
            dueKind

            dueSeriesEndAt
            alerts {
                id
                offsetMinutes
                deliveryType
                firedAt
            }
            metadata {
                highlight {
                    color
                    highlightId
                }
                savedFrom {
                    channel
                    source
                    method
                    type
                    device
                    deviceVersion
                    browser
                    browserVersion
                    appVersion
                    platform
                }
                updatedFrom {
                    type
                    device
                    deviceVersion
                    browser
                    browserVersion
                    appVersion
                    platform
                }
                chatContext {
                    isSyntheticConversation
                    sources {
                        sourceType
                        messageId
                        folderId
                        sourceFolderTitle
                        title
                        body
                        caption
                        keywords
                        ocrText
                        suggestedFolderTitle
                        sourceUrl
                        publisher
                        imageUrl
                        fileName
                        fileMime
                        createdAt
                    }
                }
            }
            folder {
                ...FolderCacheSafeFields
            }
            urlMeta {
                author
                date
                description
                article_url
                article_body
                article_pull_provider
                reddit_comments {
                    author
                    body
                    score
                    created_utc
                    permalink
                }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
                image
                gallery_images
                gallery {
                    type
                    image
                    image_name
                    media {
                        public_id
                        url
                        cdn_url
                        name
                        displayName
                        type
                        format
                        size
                        aspect_ratio
                        width
                        height
                        mime
                        duration
                        ocrText
                    }
                    width
                    height
                    aspect_ratio
                    media_url
                    media_name
                    media_cdn_url
                    media_hls_url
                    media_duration
                    media_has_audio
                }
                image_cdn_url
                logo
                publisher
                title
                url
                public_id
                width
                height
                format
                aspect_ratio
                size
                author_image
                author_image_cdn_url
                author_image_public_id
                author_image_size
                author_image_format
                author_image_aspect_ratio
                author_image_width
                author_image_height
                author_image_original
                author_image_original
                quoted_url_meta {
                    author
                    date
                    description
                    article_url
                    article_body
                    article_pull_provider
                    lang
                    image
                    gallery_images
                    gallery {
                        type
                        image
                        image_name
                        media {
                            public_id
                            url
                            cdn_url
                            name
                            displayName
                            type
                            format
                            size
                            aspect_ratio
                            width
                            height
                            mime
                            duration
                            ocrText
                        }
                        width
                        height
                        aspect_ratio
                        media_url
                        media_name
                        media_cdn_url
                        media_hls_url
                        media_duration
                        media_has_audio
                    }
                    image_cdn_url
                    image_name
                    media_url
                    media_type
                    media_width
                    media_height
                    media_duration
                    media_has_audio
                    media_audio_url
                    media_hls_url
                    logo
                    publisher
                    title
                    url
                    author_image
                    author_image_cdn_url
                    author_image_public_id
                    author_image_name
                    author_image_size
                    author_image_format
                    author_image_aspect_ratio
                    author_image_width
                    author_image_height
                    author_image_original
                }
            }
            caption
            keywords
            ocrText
            suggestedFolderTitle
            ${STRUCTURED_CONTENT_FIELDS}
            entities {
                type
                name
                confidence

                enrichment {
                    image
                    width
                    height
                    aspect_ratio
                    description
                    year
                    url
                    source

                }

            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;